export default __webpack_public_path__ + "locales/pt-BR/Ldap.json?hash=7f81344d54fb83d6939882ba602f3f52";